import gql from 'graphql-tag';

const GET_PROJECT_VIEWS = gql`
  query {
    getProjectViews {
      id
      name
      displayIcon
      viewCondition
      shared
      customView
      systemViewProperty
      module
    }
  }
`;

const GET_PROJECT_VIEW = gql`
  query($id: ID!) {
    getProjectView(id: $id) {
      id
      name
      displayIcon
      viewCondition
      shared
      customView
      systemViewProperty
    }
  }
`;

export { GET_PROJECT_VIEWS, GET_PROJECT_VIEW };
